module.exports = __webpack_public_path__ + "static/media/men-subcategory-1.a95da7ff.svg";